import { render } from "./CouponUsageBlock.vue?vue&type=template&id=006cffee&ts=true"
import script from "./CouponUsageBlock.vue?vue&type=script&lang=ts"
export * from "./CouponUsageBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__